<div
  [sbPopover]="upsellPopover"
  [sbPopoverTrigger]="'hover'"
  [sbPopoverPosition]="'right-top'"
  [sbPopoverDisabled]="!minimized()"
  [sbPopoverImprovedPositioning]="true"
>
  @if (minimized()) {
    <sb-icon name="diamond-2-cute-re" size="xl" class="text-warning" />
    @if (hasTrial() && !hasFreePlan()) {
      <!-- offset by the containers padding so it aligns with the icon -->
      <sb-notification-badge
        class="absolute top-2 right-2 translate-x-1/2 -translate-y-1/2"
        [count]="trialDays()"
        [color]="'orangeInverted'"
      />
    }
  } @else {
    <ng-container *ngTemplateOutlet="content" />
  }
</div>

<ng-template #content>
  <div class="flex flex-col gap-sm">
    <div class="flex items-center gap-sm">
      <sb-icon name="diamond-2-cute-re" size="xl" class="text-warning" />
      <h4 class="m-0 text-base font-bold text-default">
        @if (hasFreePlan()) {
          {{ "You're on the Free plan" | translate }}
        } @else {
          {{ 'Your trial ends in {{ trialDays }} days' | translate: { trialDays: trialDays() } }}
        }
      </h4>
    </div>
    <p class="reset-p text-base text-default">
      @if (hasFreePlan()) {
        {{ 'Teams on paid plans save upwards of 5 hours a week on scheduling and payroll prep.' | translate }}
      } @else {
        {{ 'Save upwards of 5 hours a week on scheduling and payroll prep.' | translate }}
      }
    </p>
    <button sb-button color="primary" class="w-full" (click)="openPlanWizard()">
      @if (hasFreePlan()) {
        {{ 'Upgrade' | translate }}
      } @else {
        {{ 'Confirm plan' | translate }}
      }
    </button>
  </div>
</ng-template>

<ng-template #upsellPopover>
  <sb-popover [maxWidth]="'15rem'" [showCloseButton]="false" [showArrow]="false">
    <ng-container *ngTemplateOutlet="content" />
  </sb-popover>
</ng-template>
